import { isAvailable, Feature } from 'App/services/FeatureHelperStandalone';

const SignalsAllowed = () => {
	return (
		isAvailable(Feature.PROSPECTING_PRO) &&
		isAvailable(Feature.PROSPECTING_SIGNALS)
	);
};

export default SignalsAllowed;
